import { Component, Prop } from "vue-property-decorator";
import { BaseComponent } from '../base-component';
import { PageDTO } from '@/model/PageDTO';
import { RegistrationMailRequestDTO } from '../../model/RegistrationMailRequestDTO';


import Bowser from "bowser";

interface FormValues {
	name: string;
	email: string;
	agreement: boolean;
}

@Component
export class RegistrationForm extends BaseComponent {
	
	formValues: FormValues = {
		name: "",
		email: "",
		agreement: false
	};

	odeslanoOk: boolean = false;
	odeslanoKo: boolean = false;

	async send() {
		var validationErros = this.getValidationErrors()
		const bowser = Bowser.parse(window.navigator.userAgent)

		if (validationErros.length > 0) {
			alert(validationErros.join('\n'));
		}
		else {
			try {
				const message = "" + this.formValues.name + "," + this.formValues.email + "," + this.formValues.agreement + "";
				const gdprInformation = "" + this.$store.timeId + "," + this.$store.langId + "," + bowser.browser.name + "," + bowser.browser.version + "," + bowser.os.name + "," + bowser.os.version + "";
				const mailBody: any[] = [message];
				const mailRequest:RegistrationMailRequestDTO = {
					mailTo: this.getText('mail-to'),
					mailToClient: this.formValues.email,
					message: this.getText('mail-template', mailBody),
					messageToClient: this.getText('mail-client-template', mailBody),

					senderName: this.getText('sender-name'),
					senderEmail: this.getText('sender-email'),
					gdprInformation: gdprInformation,
					subject: this.getText('subject')
				};

				await this.$mailService.sendRegistrationFormMail(mailRequest);
				this.odeslanoOk = true;
			}
			catch (error) {
				this.odeslanoKo = true;
			}
		}
	}

	getValidationErrors(): string[] {
		var result = [];
		if (!this.formValues.email) {
			result.push(this.getText('validation-email'))
		}
		else if (!this.validEmail(this.formValues.email)) {
			result.push(this.getText('validation-email-invalid'))
		}
		if (!this.formValues.agreement) {
			result.push(this.getText('validation-agreement'))
		}
		return result;
	}

	validEmail(email: string) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}
}

export default RegistrationForm;
